var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButton153681(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.53036
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 275.61,
    x2: 342,
    y1: 300.86,
    y2: 391.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 241.41,
    x2: 315.47,
    y1: 287.49,
    y2: 367.88,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 31.016,
    x2: 73.96,
    y1: 752.54,
    y2: 802.36,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 312.78,
    cy: 386.57,
    r: 53.036,
    gradientTransform: "matrix(-.59327 -.59327 .71505 -.71505 243.27 849.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.40816,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.9052 0 0 2.9052 4.337 -2092.4)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.97354 0 0 .97354 -228.92 451.99)",
    d: "m356.79 346.11c0 29.291-23.745 53.036-53.036 53.036s-53.036-23.745-53.036-53.036 23.745-53.036 53.036-53.036 53.036 23.745 53.036 53.036z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.9596 0 0 .9596 -224.69 456.82)",
    d: "m356.79 346.11c0 29.291-23.745 53.036-53.036 53.036s-53.036-23.745-53.036-53.036 23.745-53.036 53.036-53.036 53.036 23.745 53.036 53.036z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.87355 0 0 .87355 -198.55 486.6)",
    d: "m356.79 346.11c0 29.291-23.745 53.036-53.036 53.036s-53.036-23.745-53.036-53.036 23.745-53.036 53.036-53.036 53.036 23.745 53.036 53.036z",
    fill: "#ececec",
    filter: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.83838 0 0 .83838 -187.87 498.77)",
    d: "m356.79 346.11c0 29.291-23.745 53.036-53.036 53.036s-53.036-23.745-53.036-53.036 23.745-53.036 53.036-53.036 53.036 23.745 53.036 53.036z",
    fill: "#999",
    filter: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.80587 0 0 .80587 -177.99 510.02)",
    d: "m356.79 346.11c0 29.291-23.745 53.036-53.036 53.036s-53.036-23.745-53.036-53.036 23.745-53.036 53.036-53.036 53.036 23.745 53.036 53.036z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.75825 0 0 .75825 -162.27 528.52)",
    d: "m356.79 346.11c0 29.291-23.745 53.036-53.036 53.036s-53.036-23.745-53.036-53.036 23.745-53.036 53.036-53.036 53.036 23.745 53.036 53.036z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.786 748.76c-13.331 0.30069-26.186 7.358-33.336 19.742-7.6903 13.32-6.7139 29.266 1.1545 41.331 0.85306-26.532 21.132-46.515 46.324-45.054 8.2589 0.47907 16.054 3.2001 22.859 7.5908-3.2578-7.4498-8.8171-13.953-16.394-18.327-6.4867-3.7451-13.625-5.4393-20.608-5.2818z",
    fill: "url(#d)",
    opacity: 0.31771
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton153681);
export default __webpack_public_path__ + "static/media/button-153681.2fda82be9f46c194d36fdb030d6836c0.svg";
export { ForwardRef as ReactComponent };